module.exports = __webpack_public_path__ + "img/banner-visual-platform.1e56681a.png";